import {LOGOUT, REGISTER_OR_CONFIRM, REGISTER_OR_LOGIN, UNSUBSCRIBE} from "~/constants/api/auth/auth";
import {validatePhoneMask} from "~/composables/validations/validatePoneMask";
import userTokenCookie from "~/composables/cookie/userToken";


export const apiRegisterOrLoginPhoneMask = async (phone: string): Promise<ResponseApi> => {
    const data = await validatePhoneMask(phone);
    if (!data.status) {
        return data;
    }
    const {data:response,error:error}  = await apiRegisterOrLogin(data.data);
    if (error.value) {
        return {
            status: false,
            error: error
        };
    }
    return {
        status: true,
        data: response.value
    }
}
export const apiRegisterOrLConfirmPhoneMask = async (phone: string,verifyCode:number,name:string): Promise<ResponseApi> => {
    const data = await validatePhoneMask(phone);
    if (!data.status) {
        return data;
    }
    const {data:response,error:error}  = await apiRegisterOrConfirm({
        phone_number: data.data,
        verification_code: verifyCode,
        name: name
    });
    if (error.value) {
        return {
            status: false,
            error: error
        };
    }
    userTokenCookie().setToken(response.value.token)
    useStoreUserToken().value = response.value.token
    useStoreAuth().value=true
    return {
        status: true,
        data: response.value
    }
}
export const apiRegisterOrLogin =  async (phone: string) => {
    return await useApi(REGISTER_OR_LOGIN, 'POST',  {
        phone_number: phone
    });
}

export const apiRegisterOrConfirm =  async (payload:{
    phone_number: string,
    verification_code: number,
    name: string
}) => {
    return await useApi(REGISTER_OR_CONFIRM, 'POST',  payload);
}
export const apiLogout =  async () => {
    return await useApi(LOGOUT, 'POST');
}
export const apiUnsubscribe = async (orderNumber: string) => {
    return await useApi(UNSUBSCRIBE, 'POST', {
        order_number: orderNumber
    });
}

